import React from "react";
import { Link } from "react-router-dom";
import { Emblem } from "@/components/Emblem";

const cols = [
  {
    title: "The crossing",
    links: [
      { label: "Lincolnshire", to: "/lincolnshire" },
      { label: "Massachusetts", to: "/massachusetts" },
      { label: "The 1630 story", to: "/story/1630" },
      { label: "Plan a visit", to: "/visit" },
      { label: "2030 ledger", to: "/2030" },
    ],
  },
  {
    title: "For business",
    links: [
      { label: "The Made directory", to: "/made" },
      { label: "The Trade floor", to: "/trade" },
      { label: "Tourism", to: "/tourism" },
      { label: "Members' forum", to: "/forum" },
      { label: "Membership plans", to: "/join" },
      { label: "Exchange", to: "/exchange" },
      { label: "Advertise", to: "/advertise" },
    ],
  },
  {
    title: "This project",
    links: [
      { label: "About", to: "/about" },
      { label: "Press", to: "/press" },
      { label: "Contact", to: "/contact" },
      { label: "Journal", to: "/journal" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-[#1E1E2F] text-[#FFFAF3] border-t-2 border-[#CDA434] mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <Emblem size={48} />
              <span className="font-serif font-bold text-xl tracking-wide">Made in Boston</span>
            </div>
            <p className="font-playfair italic text-lg text-[#CDA434] mb-4">
              Two harbours. One name. A working crossing.
            </p>
            <p className="font-sans text-sm text-[#FFFAF3]/70 leading-relaxed max-w-sm mb-5">
              A private crossing, held in public — connecting Boston, Lincolnshire, the mother town,
              with Boston, Massachusetts, the daughter city.
            </p>
            <div className="space-y-1 font-sans text-sm text-[#FFFAF3]/70">
              <p>
                <a href="mailto:info@madeinboston.co.uk" className="link-underline hover:text-[#CDA434]">
                  info@madeinboston.co.uk
                </a>
              </p>
              <p>75 High Street, Boston, Lincolnshire — correspondence only</p>
            </div>
          </div>

          {cols.map((c) => (
            <div key={c.title} className="lg:col-span-2">
              <h4 className="font-sans text-xs uppercase tracking-[0.2em] font-semibold text-[#CDA434] mb-4">
                {c.title}
              </h4>
              <ul className="space-y-2.5">
                {c.links.map((l) => (
                  <li key={l.to}>
                    <Link
                      to={l.to}
                      className="font-sans text-sm text-[#FFFAF3]/75 hover:text-[#FFFAF3] link-underline"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-1">
            <h4 className="font-sans text-xs uppercase tracking-[0.2em] font-semibold text-[#CDA434] mb-4">
              Legal
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/privacy" className="font-sans text-sm text-[#FFFAF3]/75 hover:text-[#FFFAF3] link-underline">
                  Privacy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="font-sans text-sm text-[#FFFAF3]/75 hover:text-[#FFFAF3] link-underline">
                  Terms
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-[#FFFAF3]/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <span className="border border-[#CDA434]/40 bg-[#161622] px-4 py-2 font-sans text-xs uppercase tracking-widest text-[#CDA434]">
            An independent project. Not a local authority website.
          </span>
          <p className="font-sans text-xs text-[#FFFAF3]/50">
            © {new Date().getFullYear()} Made in Boston · madeinboston.co.uk
          </p>
        </div>
      </div>
    </footer>
  );
}
